import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PropsWithChildren, type JSX } from "react";

/**
 * The pickers context is internal since MUI X v9, so it can't be bridged into the r3f canvas and has
 * to be applied on both sides. Sharing the setup here keeps the two from diverging.
 *
 * @returns the date pickers localization context used by the app
 */
export function PickersLocalizationProvider({
  children,
}: PropsWithChildren): JSX.Element {
  return (
    <LocalizationProvider
      dateAdapter={AdapterLuxon}
      // Passing "default" is necessary to make luxon use the browser locale for consistent formatting of dates
      adapterLocale="default"
    >
      {children}
    </LocalizationProvider>
  );
}
